import { Component } from '@angular/core';

@Component({
  selector: 'app-product-sellers',
  templateUrl: './product-sellers.component.html',
  styleUrls: ['./product-sellers.component.scss']
})
export class ProductSellersComponent {

}
